import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updatedProgress } from "@registrationaction";
import { handleShowHide } from "@fieldshowhide";
import FieldItem from "@formdynamicfield";
import CompanyFixedFields from "./company-fixed-fields";
import { COMPANY_PREFIX } from "@constant";
import _ from "lodash";

const SectionList = (props) => {
  const {
    // parent
    source = "",
    section,
    autofill,
    formValues,
    formErrors,
    tLastFieldUpdated,
    tAllConditionalFields,
    tsectionWiseArray,

    // own
    lastFieldUpdated,
    allConditionalFields,
    sectionWiseArray,
    steps,
    updatedProgress,
    divRef,
  } = props;
  const [refKey, setRefKey] = useState(null);
  // console.log("steps :- ", steps);
  // console.log("allConditionalFields :- ", allConditionalFields);

  const updatedLastField = (field, value) => {
    // console.log("called.......", field);

    props.updatedLastFieldChanged(field, value); // used for ticketassign source, Parent props function call
  };
  useEffect(() => {
    // Iterate over formErrors to check which keys are present
    if (formErrors) {
      const errorKeys = Object.keys(formErrors || {});
      if (errorKeys?.length > 0) {
        // Choose the first error key to set the ref
        setRefKey(errorKeys?.[0]);
      }
    }
  }, [formErrors]); // Trigger whenever formErrors change

  const renderFields = () => {
    // console.log("lastFieldUpdated :- ", lastFieldUpdated);
    // console.log("formValues :- ", formValues);
    let hiddenlist = [
      `${COMPANY_PREFIX}sponsoremail`,
      `${COMPANY_PREFIX}email`,
    ];
    let renderFieldsArr = [];
    for (let pi = 0; pi < section?.elements?.length; pi++) {
      let field = section?.elements[pi];
      let name = field?.name;

      let ishidden = false;
      if (source === "ticketassign") {
        ishidden = handleShowHide(
          name,
          formValues,
          autofill,
          tLastFieldUpdated,
          tAllConditionalFields,
          tsectionWiseArray
        );
      } else {
        ishidden = handleShowHide(
          name,
          formValues,
          autofill,
          lastFieldUpdated,
          allConditionalFields,
          sectionWiseArray,
          steps,
          updatedProgress
        );
      }

      // console.log("ishidden :- ", name, ishidden);
      // console.log("-------------------");

      if (ishidden === 0 && !_.includes(hiddenlist, name))
        renderFieldsArr.push(
          <div
            key={`section_list_key_${pi}`}
            ref={name === refKey ? divRef : null}
          >
            <FieldItem
              key={name}
              source={source}
              form={field}
              autofill={autofill}
              formValues={formValues}
              updatedLastFieldChanged={updatedLastField} // used for ticketassign source
            />
          </div>
        );
    }

    // console.log("renderFieldsArr :- ", renderFieldsArr);
    return renderFieldsArr;
  };

  return (
    <div className="rounded-xl border border-default">
      <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
        <div className="custom-text-primary-md-medium">{section?.label}</div>
        <div
          className="custom-text-secondary-sm-medium"
          dangerouslySetInnerHTML={{
            __html: section?.description.replace(/\n/g, "<br>"),
          }}
        />
      </div>
      <div className="base-form bg-white rounded-b-xl px-6 py-4">
        {section.name !== `${COMPANY_PREFIX}companydetails` ? (
          renderFields()
        ) : (
          <CompanyFixedFields autofill={autofill} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    steps: state.progressArray,
    lastFieldUpdated: state.lastFieldUpdated,
    allConditionalFields: state.allConditionalFields,
    sectionWiseArray: state.sectionWiseFormArray,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updatedProgress }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SectionList);
